/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { Col, Row } from 'antd';
import landingVideo from '../../video/landingPage.webm';
import ConfirmationScreen from '../../components/ConfirmationScreen';
import { Container } from './styles';
import Login from './Login';
import SignUp from './SignUp';
import ForgotPassword from './ForgotPassword';
import { USER_AUTHENTICATION_PAGE, RESET_USER_PASSWORD } from './translationValues';
import { ENTERPRISE_ENV } from '../../utils/helper';
import Ldap from './Ldap'

const NAMESPACES = ['USER_AUTHENTICATION_PAGE', 'RESET_USER_PASSWORD'];
const RESET_USER_PWD = 'RESET_USER_PASSWORD';

const Authentication = props => {
  const { visiblePage, t } = props;
  const [currentPage, setCurrentPage] = useState('login');
  const buttonList = ['Login', 'Register'];

  useEffect(() => {
    setCurrentPage(visiblePage);
    setTimeout(() => {
      console.log("document.rewardful in Authentication :: ", document.rewardful ? document.rewardful()?.coupon : undefined);
    }, 10);
  }, []);

  return (
    <Container>
      <Row>
        <Col span={10} lg={currentPage === 'redirect' ? 24 : 12} md={24} sm={24} xs={24}>
          {currentPage === 'ldap' && <Ldap />}
          {currentPage === 'redirect' && <Login setCurrentPage={setCurrentPage} initialLoading={true} />}
          {currentPage === 'register' && <SignUp setCurrentPage={setCurrentPage} />}
          {['login', 'createPassword'].includes(currentPage) && (
            <Login setCurrentPage={setCurrentPage} />
          )}
          {currentPage === 'forgotPassword' && (
            <ForgotPassword passwordUpdated={() => setCurrentPage('login')} />
          )}
          {currentPage === 'emailVerification' && (
            <ConfirmationScreen
              buttonLabel={t(`${RESET_USER_PWD}:${RESET_USER_PASSWORD.BACK_TO_LOGIN_BUTTON.key}`, RESET_USER_PASSWORD.BACK_TO_LOGIN_BUTTON.value)}
              title={t(`${RESET_USER_PWD}:${RESET_USER_PASSWORD.RESET_PASSWORD_MAIL_CONFIRMATION_TITLE.key}`, RESET_USER_PASSWORD.RESET_PASSWORD_MAIL_CONFIRMATION_TITLE.value)}
              content={t(`${RESET_USER_PWD}:${RESET_USER_PASSWORD.RESET_PASSWORD_MAIL_CONFIRMATION_DESCRIPTION.key}`, RESET_USER_PASSWORD.RESET_PASSWORD_MAIL_CONFIRMATION_DESCRIPTION.value)}
              onClick={() => {
                setCurrentPage('login');
              }}
              alt={t(`${RESET_USER_PWD}:${RESET_USER_PASSWORD.WAITING_FOR_EMAIL_VERIFICATION_ALT_TEXT.key}`, RESET_USER_PASSWORD.WAITING_FOR_EMAIL_VERIFICATION_ALT_TEXT.value)}
            />
          )}
        </Col>
        {currentPage !== 'redirect' &&
        <Col span={14} lg={12} md={12} sm={24} xs={24}>
          <section class="outter option2">
            <section class="video-container">
              <video muted autoPlay loop>
                <source src={landingVideo} type="video/webm" />
              </video>
              <div className="callout">{t(USER_AUTHENTICATION_PAGE.GROW_WITH_US_VIDEO_TITLE.key, USER_AUTHENTICATION_PAGE.GROW_WITH_US_VIDEO_TITLE.value)}</div>
              {(!ENTERPRISE_ENV && ['register', 'login'].includes(currentPage)) && (
                <div className="side-button">
                  {buttonList.map(list => {
                    return (
                      <div
                        className={`btn login-btn ${currentPage === list.toLowerCase() ? 'active' : 'non-active'
                          }`}
                        onClick={() => {
                          setCurrentPage(list.toLowerCase());
                        }}
                      >
                        {t(list, { list })}
                      </div>
                    );
                  })}
                </div>
              )}
              <div class="content">
                <div class="desc glacial">
                  {t(USER_AUTHENTICATION_PAGE.STREAMLINE_MULTILINGUAL_COMMUNICATION_MESSAGE.key, USER_AUTHENTICATION_PAGE.STREAMLINE_MULTILINGUAL_COMMUNICATION_MESSAGE.value)}, <br /> {t(USER_AUTHENTICATION_PAGE.DELIGHT_CUSTOMER_WORLDWIDE_MESSAGE.key, USER_AUTHENTICATION_PAGE.DELIGHT_CUSTOMER_WORLDWIDE_MESSAGE.value)}
                </div>
              </div>
              <div class="footer-button">
                <div className="button-border"> {t(USER_AUTHENTICATION_PAGE.PRODUCT_LANGUAGES_DESCRIPTION.key, USER_AUTHENTICATION_PAGE.PRODUCT_LANGUAGES_DESCRIPTION.value)}</div>
                <div className="button-border"> {t(USER_AUTHENTICATION_PAGE.PRODUCT_CHANNELS_USED_DESCRIPTION.key, USER_AUTHENTICATION_PAGE.PRODUCT_CHANNELS_USED_DESCRIPTION.value)}</div>
              </div>
            </section>
          </section>
        </Col>}
      </Row>
    </Container>
  );
};

export default withTranslation(NAMESPACES)(Authentication);
